import React from "react";
import { Home, Building2, Crown, ArrowUpRight } from "lucide-react";

const SERVICES = [
  {
    icon: Home,
    title: "Residential",
    tag: "Homes & Acreage",
    points: ["Timber paling", "Colorbond steel", "Chain link & pool", "Side gates"],
    img: "https://customer-assets.emergentagent.com/job_fencing-hub-2/artifacts/30o593ao_IMG_20260511_223641.jpg",
  },
  {
    icon: Building2,
    title: "Commercial",
    tag: "Sites & Estates",
    points: ["Security fencing", "Site hoarding", "Industrial chain link", "Sliding gates"],
    img: "https://customer-assets.emergentagent.com/job_fencing-hub-2/artifacts/cl3zp13v_IMG_20260416_001714.jpg",
  },
  {
    icon: Crown,
    title: "Ornamental",
    tag: "Iron & Aluminium",
    points: ["Wrought iron", "Powder-coated alloy", "Custom gates", "Heritage repairs"],
    img: "https://customer-assets.emergentagent.com/job_fencing-hub-2/artifacts/4qethzih_IMG_20260511_224125.jpg",
  },
];

export default function Services({ onQuoteClick }) {
  return (
    <section id="services" data-testid="services-section" className="relative bg-[#0D0D0D] py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 items-end mb-16">
          <div className="lg:col-span-7">
            <div className="text-xs tracking-[0.3em] uppercase text-[#FF5A00] font-bold mb-4">
              [ 01 ] What We Build
            </div>
            <h2 className="font-heading uppercase text-white text-5xl lg:text-7xl leading-[0.9] tracking-tighter">
              Three Trades.<br />
              <span className="text-[#FF5A00]">One Crew.</span>
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="text-[#A3A3A3] text-lg leading-relaxed">
              From a backyard reno to a 200m commercial run — the same set of
              tools, the same standard, the same Dan on site.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-px bg-[#333]">
          {SERVICES.map((svc) => (
            <div
              key={svc.title}
              data-testid={`service-${svc.title.toLowerCase()}`}
              className="group bg-[#0D0D0D] hover:bg-[#1A1A1A] transition-colors p-8 lg:p-10 flex flex-col"
            >
              <div className="relative h-56 mb-8 overflow-hidden">
                <img
                  src={svc.img}
                  alt={svc.title}
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-[#0D0D0D]/30 group-hover:bg-transparent transition-colors" />
                <div className="absolute top-4 left-4 w-12 h-12 bg-[#FF5A00] flex items-center justify-center">
                  <svc.icon className="w-6 h-6 text-black" strokeWidth={2} />
                </div>
              </div>
              <div className="text-xs tracking-[0.3em] uppercase text-[#FF5A00] mb-3">
                {svc.tag}
              </div>
              <h3 className="font-heading text-white text-4xl uppercase tracking-tight mb-6">
                {svc.title}
              </h3>
              <ul className="space-y-2 mb-8">
                {svc.points.map((p) => (
                  <li key={p} className="text-[#D4D4D4] flex items-start gap-3">
                    <span className="text-[#FF5A00] mt-1">▸</span>
                    {p}
                  </li>
                ))}
              </ul>
              <button
                onClick={onQuoteClick}
                data-testid={`service-${svc.title.toLowerCase()}-quote`}
                className="mt-auto flex items-center justify-between text-white border-t border-[#333] pt-5 font-heading tracking-[0.2em] uppercase text-sm group-hover:text-[#FF5A00] transition-colors"
              >
                <span>Quote This Trade</span>
                <ArrowUpRight className="w-5 h-5" />
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
